import { defineMessage } from '../../services/localization';

export const messages = {
    title: defineMessage('please_confirm_the_action'),
    areYouSure: defineMessage('are_you_sure_you_want_to_do_this'),
    buttonCancel: defineMessage('cancel'),
    buttonConfirm: defineMessage('yes_im_sure'),
};
